import qweBaseField from "../BaseField"

export default{
    mixins: [qweBaseField]
}